<script>
    import { createEventDispatcher } from "svelte";
    import Spinner from "./spinner.svelte";
    export let showModal = false;  
    export let sizeClass="modal-xl"; 
    export let zindex="1050";
    export let marginTop="0px";
    export let targetClass="";
    export let showFooter = true;
    export let disableBackground = "static";
    export let isPageLoading = false;
    export let hideScrollY = false;
    $:{showFooter = !isPageLoading}
    let dispatch = new createEventDispatcher();   
    const modal = node=> {    
        if(hideScrollY)
        jQuery('.modal-body').css("overflow-y","visible");
        jQuery(node).on('shown.bs.modal', function (e) {
      dispatch("show")
      })
    // the node has been mounted in the DOM  
    jQuery(node).modal("show");  
		return {      
			destroy() {
                // the node has been removed from the DOM
                jQuery(node).modal("hide");                
			}
		};
    }
    
</script>
<style>

.modal-backdrop.show:nth-of-type(2) {
            z-index: 1051 !important;
        }
</style>
{#if showModal}
<div
class="modal fade {targetClass}"
tabindex="-1"
role="dialog"
data-backdrop={disableBackground}
aria-labelledby="myLargeModalLabel"
aria-hidden="true" style="z-index:{zindex};margin-top:{marginTop};" use:modal>
<div class="modal-dialog {sizeClass}">
    <div class="modal-content">
        {#if isPageLoading}
    <Spinner marginTop={"50px"} marginBottom={"50px"}/>
        {:else}
        <div class="modal-header">
           <slot name="header"/>
           <button type="button" class="close" data-dismiss="modal" on:click={()=> {showModal=false;dispatch("close")}}>&times;</button>
        </div>

        <div class="modal-body">
         <slot name="content"/>
        </div>
        {#if showFooter}
        <div class="modal-footer">
            
            <slot name="footer"/>
        
            <button
                type="button"
                class="btn"
                data-dismiss="modal" on:click={()=>{ showModal=false;dispatch("close")}}>Close</button>
        
            
        </div>
        {/if}
        {/if}
    </div>
</div>
</div>

{/if}
